import {
  Button,
  Input,
  Select,
  Form,
  notification,
  PageHeader,
  Col,
  Row,
  InputNumber,
} from "antd";
import { useEffect, useState } from "react";
import { Prompt, useHistory } from "react-router-dom";
import "../../Tools/customStyles.css";
import { useAuth } from "../../context/auth";
import { listPowerType } from "../../utils/formatter";
import IconEvCharger from "../../static/icon/IconEvCharger";

const ChargerBrandSetting = ({ match: { params: { id } } }) => {
  const history = useHistory();
  const { accessToken } = useAuth();

  const [form] = Form.useForm();

  const [change, setChange] = useState(false);
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    if (id === 'new') return;

    async function getChargerBrand() {
      const url = new URL('/api/charger-brand/' + id, window.location);

      const res = await fetch(url, {
        headers: { 'X-ACCESS-TOKEN': accessToken },
      });
      if (res.ok) {
        const { chargerBrand } = await res.json();
        form.setFieldsValue(chargerBrand);
      } else {
        notification["error"]({
          message: "Something went wrong !",
          description: `Please re-login or contact web admin. (Code: ${await res.json().then(data => data.message)})`,
        });
      }
    }

    setChange(false);
    getChargerBrand();
  }, [accessToken, form, id]);

  const save = async (values) => {
    setDisabled(true);
    setChange(false);

    const url = new URL(id === 'new' ? '/api/charger-brand' : '/api/charger-brand/' + id, window.location);

    const res = await fetch(url, {
      method: id === 'new' ? 'POST' : 'PATCH',
      headers: {
        'X-ACCESS-TOKEN': accessToken,
        'content-type': 'application/json',
      },
      body: JSON.stringify(values),
    });
    if (res.ok) {
      notification["success"]({
        message: "Successfully saved data.",
      });
      history.push({
        pathname: "/charger-brand",
        searchValue: history.location.searchValue,
        pageValue: history.location.pageValue,
      });
    } else {
      notification["error"]({
        message: "Something went wrong !",
        description: `Please re-login or contact web admin. (Code: ${await res.json().then(data => data.message)})`,
      });
    }

    setDisabled(false);
    setChange(true);
  };

  return (
    <>
      <div className="flex justify-between items-center mt-2">
        <PageHeader
          style={{ padding: 0, width: "100%" }}
          title={
            <span className="flex items-center mt-2">
              <IconEvCharger /> &nbsp;&nbsp;Charger Brand Setting
            </span>
          }
        />
      </div>
      <div className="content">
        <div className="search">
          <Form
            form={form}
            onFinish={save}
            onFieldsChange={() => setChange(true)}
            className="search_inline row m-auto w-3/4 py-6"
          >
            <Row gutter={40} style={{ marginTop: 30 }}>
              <Col sm={24} md={24} lg={12}>
                <Form.Item
                  label="Charger Brand ID"
                  name="id"
                  colon={false}
                  className="mt-2"
                >
                  <Input
                    placeholder="Auto generate"
                    disabled={true}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={40} style={{ marginTop: 15 }}>
              <Col span={24}>
                <Form.Item
                  label="Charger Brand Name"
                  name="name"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Charger Brand Name is required.",
                    },
                    {
                      whitespace: true,
                      message: "Charger Brand Name is not whitespace",
                    },
                  ]}
                  className="mt-2"
                >
                  <Input
                    placeholder="Charger Brand Name"
                    maxLength={255}
                  />
                </Form.Item>
              </Col>
              <Col span={24} lg={12}>
                <Form.Item
                  label="Power Type"
                  name="powerType"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Power Type is required.",
                    },
                  ]}
                  className="mt-2"
                >
                  <Select
                    placeholder="Select Power Type"
                    showSearch
                    options={listPowerType.map(type => ({
                      value: type.name,
                      label: type.value,
                    }))}
                  />
                </Form.Item>
              </Col>
              <Col span={24} lg={12}>
                <Form.Item
                  label="Min Power"
                  name="minPowerKw"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Min Power is required.",
                    },
                  ]}
                  className="mt-2"
                >
                  <InputNumber
                    formatter={(value) => {
                      var parts = value.toString().split(".");
                      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                      return parts.join(".");
                    }}
                    parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                    min={0.01}
                    maxLength={10}
                    step="0.01"
                    className="w-full"
                    placeholder="0"
                    name="minPowerKw"
                    allowClear
                    addonAfter={
                      <span className="text-gray-600">
                        kW
                      </span>
                    }
                  />
                </Form.Item>
              </Col>
            </Row>

            <div className="m-auto pt-6 flex justify-center space-x-4">
              <Form.Item colon={false}>
                <Button
                  className="w-36"
                  type="primary"
                  ghost
                  shape="round"
                  htmlType="button"
                  onClick={() => {
                    history.push({
                      pathname: "/charger-brand",
                      searchValue: history.location.searchValue,
                      pageValue: history.location.pageValue,
                    });
                  }}
                >
                  Cancel
                </Button>
              </Form.Item>
              <Form.Item colon={false}>
                <Button
                  className="w-36"
                  key="save"
                  type="primary"
                  shape="round"
                  htmlType="submit"
                  disabled={disabled}
                >
                  Save
                </Button>
              </Form.Item>
            </div>
          </Form>
        </div>
      </div>
      <Prompt when={change} message="Changes will not be saved. Do you want to proceed ?" />
    </>
  );
};
export default ChargerBrandSetting;
